/* LUS · Стенд — preset switching + lazy video.
   Null-safe and idempotent, like the rest of the theme: re-runs on
   shopify:section:load and binds every element at most once.

   Two kinds of video live in a stand:
     • background feeds (.stg-game / .stg-cam) — always running while the stand
       is on screen;
     • preview clips that ARE the art (video.stg-ov on the screens stand) — only
       the selected one may load and play, otherwise ten clips download at once.
*/
(function () {
  if (window.__lusStage) { window.__lusStage.init(); return; }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setBox(el, p, v) {
    if (!v || v.length !== 4) return;
    el.style.setProperty('--' + p + 'x', v[0] + '%');
    el.style.setProperty('--' + p + 'y', v[1] + '%');
    el.style.setProperty('--' + p + 'w', v[2] + '%');
    el.style.setProperty('--' + p + 'h', v[3] + '%');
  }

  function isVid(el) { return el && el.tagName === 'VIDEO'; }

  function play(v) {
    if (!isVid(v) || reduce) return;
    var pr = v.play();
    if (pr && pr.catch) pr.catch(function () {});
  }

  function init() {
    document.querySelectorAll('.lus-stage').forEach(function (root) {
      if (root.dataset.lusStage) return;
      root.dataset.lusStage = '1';

      var scene = root.querySelector('.stg-scene');
      var picks = [].slice.call(root.querySelectorAll('.stg-pick'));
      var ovs = [].slice.call(root.querySelectorAll('.stg-ov'));
      var feeds = [].slice.call(root.querySelectorAll('.stg-box video'));
      var nameEl = root.querySelector('[data-stg-name]');
      var tagEl = root.querySelector('[data-stg-tag]');
      var cta = root.querySelector('[data-stg-cta]');
      var ctaT = cta ? cta.querySelector('.t') : null;
      if (!scene || !picks.length) return;

      var i = -1;
      var seen = false;

      function load(o) {
        if (!o || o.getAttribute('src') || !o.dataset.src) return;
        o.src = o.dataset.src;
        if (isVid(o)) o.load();
      }

      function apply(n) {
        n = (n % picks.length + picks.length) % picks.length;
        if (n === i) return;
        i = n;
        var p = picks[n];

        picks.forEach(function (b, k) {
          b.classList.toggle('on', k === n);
          b.setAttribute('aria-selected', k === n ? 'true' : 'false');
          b.tabIndex = k === n ? 0 : -1;
        });

        ovs.forEach(function (o, k) {
          if (k === n) {
            load(o);
            if (isVid(o) && seen) play(o);
          } else if (isVid(o)) {
            o.pause();
          }
          o.classList.toggle('on', k === n);
        });

        var cam = (p.dataset.cam || '').split(',');
        var game = (p.dataset.game || '').split(',');
        setBox(scene, 'g', game);
        setBox(scene, 'c', cam);
        scene.classList.toggle('no-cam', !(cam.length === 4 && parseFloat(cam[2]) > 0 && parseFloat(cam[3]) > 0));

        if (p.dataset.accent) root.style.setProperty('--accent', p.dataset.accent);
        if (nameEl) nameEl.textContent = p.dataset.name || '';
        if (tagEl) tagEl.textContent = p.dataset.tag || '';
        if (cta) {
          if (p.dataset.url) {
            cta.href = p.dataset.url;
            if (ctaT) ctaT.textContent = p.dataset.cta || 'View the pack';
            cta.hidden = false;
          } else {
            cta.hidden = true;
          }
        }

        /* Preload the neighbouring still so the next click never shows a blank
           frame. Videos are deliberately NOT preloaded — one clip at a time. */
        var nx = ovs[(n + 1) % ovs.length];
        if (nx && !isVid(nx)) load(nx);
      }

      picks.forEach(function (b, k) {
        b.addEventListener('click', function () { apply(k); });
        b.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); apply(i + 1); picks[i].focus(); }
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); apply(i - 1); picks[i].focus(); }
        });
      });

      /* Everything moving is fetched and played only while the stand is
         actually on screen. */
      function wake(on) {
        seen = on;
        feeds.forEach(function (v) {
          if (on) { load(v); play(v); } else { v.pause(); }
        });
        var act = ovs[i];
        if (isVid(act)) { if (on) { load(act); play(act); } else { act.pause(); } }
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { wake(e.isIntersecting); });
        }, { threshold: 0.2 }).observe(root);
      } else {
        wake(true);
      }

      apply(0);

      /* Preview art is not a download. This stops the casual right-click — it
         is a speed bump, not protection, and the real defence is that only a
         short, downscaled, watermarked cut is ever served. */
      if (root.classList.contains('no-grab')) {
        scene.addEventListener('contextmenu', function (e) { e.preventDefault(); });
        scene.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
    });
  }

  window.__lusStage = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();